// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WarningPopup-module__font-s-10___dGYwj {
  font-size: 10px !important;
}

.WarningPopup-module__font-s-12___gMr17 {
  font-size: 12px !important;
}

.WarningPopup-module__font-s-13___kTIDX {
  font-size: 13px !important;
}

.WarningPopup-module__font-s-14___Sw5rW {
  font-size: 14px !important;
}

.WarningPopup-module__font-s-15___NB8Aa {
  font-size: 15px !important;
}

.WarningPopup-module__font-s-16___ba2zJ {
  font-size: 16px !important;
}

.WarningPopup-module__font-s-18___dtO1M {
  font-size: 18px !important;
}

.WarningPopup-module__font-s-20___Dt6q8 {
  font-size: 20px !important;
}

.WarningPopup-module__font-s-22___FHyLL {
  font-size: 22px !important;
}

.WarningPopup-module__font-s-28___dcFnQ {
  font-size: 28px !important;
}

.WarningPopup-module__font-w-400___MAca1 {
  font-weight: 400 !important;
}

.WarningPopup-module__font-w-500___I3vco {
  font-weight: 500 !important;
}

.WarningPopup-module__font-w-600___rrwRt {
  font-weight: 600 !important;
}

.WarningPopup-module__font-w-700___oYap6 {
  font-weight: 700 !important;
}

.WarningPopup-module__p-5___js511 {
  padding: 5px !important;
}

.WarningPopup-module__p-12___Y1oOK {
  padding: 12px !important;
}

.WarningPopup-module__p-16___uVUed {
  padding: 16px !important;
}

.WarningPopup-module__p-30___VsXhX {
  padding: 30px !important;
}

.WarningPopup-module__p-b-0____l8ul {
  padding-bottom: 0 !important;
}

.WarningPopup-module__p-b-5___EjdHJ {
  padding-bottom: 5px !important;
}

.WarningPopup-module__p-b-10___hj9NU {
  padding-bottom: 10px !important;
}

.WarningPopup-module__p-b-12___odOdR {
  padding-bottom: 12px !important;
}

.WarningPopup-module__p-b-16___aV0gu {
  padding-bottom: 16px !important;
}

.WarningPopup-module__p-b-18____2RwC {
  padding-bottom: 18px !important;
}

.WarningPopup-module__p-b-20___kGLlT {
  padding-bottom: 20px !important;
}

.WarningPopup-module__p-b-25___1KqZG {
  padding-bottom: 25px !important;
}

.WarningPopup-module__p-b-30___y84zF {
  padding-bottom: 30px !important;
}

.WarningPopup-module__p-b-50___XYqcZ {
  padding-bottom: 50px !important;
}

.WarningPopup-module__p-t-0___vVcqk {
  padding-top: 0 !important;
}

.WarningPopup-module__p-t-12___fkGf_ {
  padding-top: 12px !important;
}

.WarningPopup-module__p-t-16___X0X55 {
  padding-top: 16px !important;
}

.WarningPopup-module__p-t-18___FfFhT {
  padding-top: 18px !important;
}

.WarningPopup-module__p-t-20___Zew2W {
  padding-top: 20px !important;
}

.WarningPopup-module__p-t-30____xO5H {
  padding-top: 30px !important;
}

.WarningPopup-module__p-t-40___cti43 {
  padding-top: 40px !important;
}

.WarningPopup-module__p-t-50___zlPOZ {
  padding-top: 50px !important;
}

.WarningPopup-module__p-l-20___b3Wsd {
  padding-left: 20px !important;
}

.WarningPopup-module__p-l-30___zU66E {
  padding-left: 30px !important;
}

.WarningPopup-module__p-l-40___yMnt_ {
  padding-left: 40px !important;
}

.WarningPopup-module__p-r-16___XIWl6 {
  padding-right: 16px !important;
}

.WarningPopup-module__p-r-20___arTBf {
  padding-right: 20px !important;
}

.WarningPopup-module__p-r-30___C6jmP {
  padding-right: 30px !important;
}

.WarningPopup-module__p-r-50___CB6kl {
  padding-right: 50px !important;
}

.WarningPopup-module__p-r-60___UJL4b {
  padding-right: 60px !important;
}

.WarningPopup-module__m-b-1___Ue5vq {
  margin-bottom: 1px !important;
}

.WarningPopup-module__m-b-2___Q9ou1 {
  margin-bottom: 2px !important;
}

.WarningPopup-module__m-b-6___C_V7k {
  margin-bottom: 6px !important;
}

.WarningPopup-module__m-b-8___UNhwc {
  margin-bottom: 8px !important;
}

.WarningPopup-module__m-b-10___nIsdW {
  margin-bottom: 10px !important;
}

.WarningPopup-module__m-b-14___lsx5A {
  margin-bottom: 14px !important;
}

.WarningPopup-module__m-b-16____rBH0 {
  margin-bottom: 16px !important;
}

.WarningPopup-module__m-b-20___iQjJk {
  margin-bottom: 20px !important;
}

.WarningPopup-module__m-b-22___cSG_O {
  margin-bottom: 22px !important;
}

.WarningPopup-module__m-b-24___eWByA {
  margin-bottom: 24px !important;
}

.WarningPopup-module__m-b-30___TdCiZ {
  margin-bottom: 30px !important;
}

.WarningPopup-module__m-b-32___Q4Whe {
  margin-bottom: 32px !important;
}

.WarningPopup-module__m-b-40___Kq4qj {
  margin-bottom: 40px !important;
}

.WarningPopup-module__m-t-2___Cyy8e {
  margin-top: 2px !important;
}

.WarningPopup-module__m-t-3___tWJGV {
  margin-top: 3px !important;
}

.WarningPopup-module__m-t-4___Y43IZ {
  margin-top: 4px !important;
}

.WarningPopup-module__m-t-5___rcuHU {
  margin-top: 5px !important;
}

.WarningPopup-module__m-t-8___MukTv {
  margin-top: 8px !important;
}

.WarningPopup-module__m-t-10___nkqho {
  margin-top: 10px !important;
}

.WarningPopup-module__m-t-15___YIC40 {
  margin-top: 15px !important;
}

.WarningPopup-module__m-t-16___Y61xl {
  margin-top: 16px !important;
}

.WarningPopup-module__m-t-20___sPj3b {
  margin-top: 20px !important;
}

.WarningPopup-module__m-t-22___CcBIB {
  margin-top: 22px !important;
}

.WarningPopup-module__m-t-30___N2oPp {
  margin-top: 30px !important;
}

.WarningPopup-module__m-t-32___enwKP {
  margin-top: 32px !important;
}

.WarningPopup-module__m-l-auto___xOjCP {
  margin-left: auto !important;
}

.WarningPopup-module__m-l-4___i4AGF {
  margin-left: 4px !important;
}

.WarningPopup-module__m-l-5___Fi2bG {
  margin-left: 5px !important;
}

.WarningPopup-module__m-l-6___jMnVQ {
  margin-left: 6px !important;
}

.WarningPopup-module__m-l-8___PBq5r {
  margin-left: 8px !important;
}

.WarningPopup-module__m-l-10___Dbf0B {
  margin-left: 10px !important;
}

.WarningPopup-module__m-l-16___d84Xu {
  margin-left: 16px !important;
}

.WarningPopup-module__m-l-20___VH7xH {
  margin-left: 20px !important;
}

.WarningPopup-module__m-l-24___Ff6yR {
  margin-left: 24px !important;
}

.WarningPopup-module__m-l-30____so32 {
  margin-left: 30px !important;
}

.WarningPopup-module__m-l-35___LJivh {
  margin-left: 35px !important;
}

.WarningPopup-module__m-l-40___XfdW1 {
  margin-left: 40px !important;
}

.WarningPopup-module__m-r-8___FdWAY {
  margin-right: 8px !important;
}

.WarningPopup-module__m-r-10___dNeJ4 {
  margin-right: 10px !important;
}

.WarningPopup-module__m-r-16___RaQR6 {
  margin-right: 16px !important;
}

.WarningPopup-module__m-r-20___Vxc2N {
  margin-right: 20px !important;
}

.WarningPopup-module__m-r-24___ckHcw {
  margin-right: 24px !important;
}

.WarningPopup-module__m-r-30___Wt6f_ {
  margin-right: 30px !important;
}

.WarningPopup-module__m-r-40___jmO06 {
  margin-right: 40px !important;
}

.WarningPopup-module__border-r-3___Hp369 {
  border-radius: 3px !important;
}

.WarningPopup-module__border-r-4___cq2Cn {
  border-radius: 4px !important;
}

.WarningPopup-module__border-r-6___jCdl1 {
  border-radius: 6px !important;
}

.WarningPopup-module__border-r-10___Hn5kz {
  border-radius: 10px !important;
}

.WarningPopup-module__border-r-12___cwuew {
  border-radius: 12px !important;
}

.WarningPopup-module__border-r-16___D2bVh {
  border-radius: 16px !important;
}

.WarningPopup-module__border-r-50___I_tji {
  border-radius: 50% !important;
}

.WarningPopup-module__primary-border___wqmvB {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.WarningPopup-module__primary-border-b___s9y3Q {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.WarningPopup-module__primary-border-t___BCFeI {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.WarningPopup-module__primary-border-l___U0uMH {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.WarningPopup-module__primary-border-r___u3Bim {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.WarningPopup-module__secondary-border___QJ0O0 {
  border: 1px solid #637768;
}

.WarningPopup-module__secondary-border-b___lolVn {
  border-bottom: 1px solid #637768;
}

.WarningPopup-module__secondary-border-t___opdjC {
  border-top: 1px solid #637768;
}

.WarningPopup-module__secondary-border-l___hqOUC {
  border-left: 1px solid #637768;
}

.WarningPopup-module__secondary-border-r___rYr3K {
  border-right: 1px solid #637768;
}

.WarningPopup-module__gap-0___g2NWz {
  gap: 0 !important;
}

.WarningPopup-module__gap-2___q268p {
  gap: 2px !important;
}

.WarningPopup-module__gap-4___hqQQ_ {
  gap: 4px !important;
}

.WarningPopup-module__gap-5___yIE8u {
  gap: 5px !important;
}

.WarningPopup-module__gap-6___QwRyR {
  gap: 6px !important;
}

.WarningPopup-module__gap-8___tAXZZ {
  gap: 8px !important;
}

.WarningPopup-module__gap-10___loBvk {
  gap: 10px !important;
}

.WarningPopup-module__gap-12___MV9a9 {
  gap: 12px !important;
}

.WarningPopup-module__gap-14___Z7NhK {
  gap: 14px !important;
}

.WarningPopup-module__gap-16___QUOEn {
  gap: 16px !important;
}

.WarningPopup-module__gap-18___m_IKQ {
  gap: 18px !important;
}

.WarningPopup-module__gap-20___YGw00 {
  gap: 20px !important;
}

.WarningPopup-module__gap-24___dn3ob {
  gap: 24px !important;
}

.WarningPopup-module__gap-26___OOUcZ {
  gap: 26px !important;
}

.WarningPopup-module__gap-30___NAtDb {
  gap: 30px !important;
}

.WarningPopup-module__gap-32___gTPbp {
  gap: 32px !important;
}

.WarningPopup-module__gap-40___P9mKQ {
  gap: 40px !important;
}

.WarningPopup-module__gap-50___ktdGX {
  gap: 50px !important;
}

.WarningPopup-module__flex-1___TXeGO {
  flex: 1;
}

.WarningPopup-module__flex-none___HxZNX {
  flex: none !important;
}

.WarningPopup-module__flex-column___DokdP {
  display: flex;
  flex-direction: column !important;
}

.WarningPopup-module__flex-row___cJr6s {
  display: flex;
  flex-direction: row !important;
}

.WarningPopup-module__vertically-centered___Wl9m8 {
  display: flex;
  align-items: center !important;
}

.WarningPopup-module__horizontally-centered___huZis {
  display: flex;
  justify-content: center !important;
}

.WarningPopup-module__horizontally-end___XuHBu {
  display: flex;
  justify-content: end !important;
}

.WarningPopup-module__vertically-start___QI0hC {
  display: flex;
  align-items: start !important;
}

.WarningPopup-module__space-between___bxAha {
  display: flex;
  justify-content: space-between !important;
}

.WarningPopup-module__flex-wrap___sQocx {
  flex-wrap: wrap !important;
}

.WarningPopup-module__height-100___f_c2e {
  height: 100%;
}

.WarningPopup-module__width-50___Yo5py {
  width: 50% !important;
}

.WarningPopup-module__width-100___JS4o3 {
  width: 100%;
}

.WarningPopup-module__cursor-pointer___HVqj9 {
  cursor: pointer;
}

.WarningPopup-module__cursor-not-allowed___Ov_WW {
  cursor: not-allowed !important;
}

.WarningPopup-module__absolute-centered___dj5_G {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.WarningPopup-module__absolute___S9Bud {
  position: absolute;
}

.WarningPopup-module__relative___aD53w {
  position: relative;
}

.WarningPopup-module__fixed___yGIGs {
  position: fixed;
}

.WarningPopup-module__visible___pCBGi {
  opacity: 1;
}

.WarningPopup-module__invisible___tHbEg {
  opacity: 0;
}

.WarningPopup-module__col-90___iA8ks {
  width: 90% !important;
}

.WarningPopup-module__col-auto___wvlo6 {
  width: auto !important;
}

.WarningPopup-module__medical-tabs___duvtU {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.WarningPopup-module__medical-table-new___wmNjb {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.WarningPopup-module__medical-table-new___wmNjb:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.WarningPopup-module__medical-table-new___wmNjb::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.WarningPopup-module__medical-table-new___wmNjb::-webkit-scrollbar-track {
  display: none;
}
.WarningPopup-module__medical-table-new___wmNjb.WarningPopup-module__no-pagination___oWLTh {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.WarningPopup-module__medical-table-new___wmNjb.WarningPopup-module__no-pagination___oWLTh:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.WarningPopup-module__medical-table-new___wmNjb.WarningPopup-module__no-pagination___oWLTh::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.WarningPopup-module__medical-table-new___wmNjb.WarningPopup-module__no-pagination___oWLTh::-webkit-scrollbar-track {
  display: none;
}

.WarningPopup-module__medical-table-empty___UEBt0 {
  padding: 14px 40px !important;
}

.WarningPopup-module__icon-btn___jnHWy {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.WarningPopup-module__search-icon___tsbfu {
  width: 24px;
  height: 24px;
  align-self: center;
}

.WarningPopup-module__disable-select___GqcOW {
  user-select: none;
}

.WarningPopup-module__break-word___1wX1Q {
  word-break: break-word;
}

.WarningPopup-module__popup-clear-btn___A9hJH {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.WarningPopup-module__scroll-m-b-20___inSQS {
  scroll-margin-bottom: 20px;
}

.WarningPopup-module__wrapper___VX3_U {
  padding: 20px 30px 45px 30px;
}
.WarningPopup-module__wrapper___VX3_U .WarningPopup-module__message___NuFg4 {
  color: black;
  white-space: pre-line;
}

.WarningPopup-module__buttonsContainer___ek_et {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
  justify-content: end;
  padding: 20px 30px;
  display: flex;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/WarningPopup/WarningPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,4BAAA;AA8pBF;AA5pBE;EACE,YAAA;EACA,qBAAA;AA8pBJ;;AA1pBA;EACE,2CAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AA6pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.wrapper {\n  padding: 20px 30px 45px 30px;\n\n  .message {\n    color: get-color(black);\n    white-space: pre-line;\n  }\n}\n\n.buttonsContainer {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n  justify-content: end;\n  padding: 20px 30px;\n  display: flex;\n  gap: 16px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `WarningPopup-module__font-s-10___dGYwj`,
	"fontS12": `WarningPopup-module__font-s-12___gMr17`,
	"fontS13": `WarningPopup-module__font-s-13___kTIDX`,
	"fontS14": `WarningPopup-module__font-s-14___Sw5rW`,
	"fontS15": `WarningPopup-module__font-s-15___NB8Aa`,
	"fontS16": `WarningPopup-module__font-s-16___ba2zJ`,
	"fontS18": `WarningPopup-module__font-s-18___dtO1M`,
	"fontS20": `WarningPopup-module__font-s-20___Dt6q8`,
	"fontS22": `WarningPopup-module__font-s-22___FHyLL`,
	"fontS28": `WarningPopup-module__font-s-28___dcFnQ`,
	"fontW400": `WarningPopup-module__font-w-400___MAca1`,
	"fontW500": `WarningPopup-module__font-w-500___I3vco`,
	"fontW600": `WarningPopup-module__font-w-600___rrwRt`,
	"fontW700": `WarningPopup-module__font-w-700___oYap6`,
	"p5": `WarningPopup-module__p-5___js511`,
	"p12": `WarningPopup-module__p-12___Y1oOK`,
	"p16": `WarningPopup-module__p-16___uVUed`,
	"p30": `WarningPopup-module__p-30___VsXhX`,
	"pB0": `WarningPopup-module__p-b-0____l8ul`,
	"pB5": `WarningPopup-module__p-b-5___EjdHJ`,
	"pB10": `WarningPopup-module__p-b-10___hj9NU`,
	"pB12": `WarningPopup-module__p-b-12___odOdR`,
	"pB16": `WarningPopup-module__p-b-16___aV0gu`,
	"pB18": `WarningPopup-module__p-b-18____2RwC`,
	"pB20": `WarningPopup-module__p-b-20___kGLlT`,
	"pB25": `WarningPopup-module__p-b-25___1KqZG`,
	"pB30": `WarningPopup-module__p-b-30___y84zF`,
	"pB50": `WarningPopup-module__p-b-50___XYqcZ`,
	"pT0": `WarningPopup-module__p-t-0___vVcqk`,
	"pT12": `WarningPopup-module__p-t-12___fkGf_`,
	"pT16": `WarningPopup-module__p-t-16___X0X55`,
	"pT18": `WarningPopup-module__p-t-18___FfFhT`,
	"pT20": `WarningPopup-module__p-t-20___Zew2W`,
	"pT30": `WarningPopup-module__p-t-30____xO5H`,
	"pT40": `WarningPopup-module__p-t-40___cti43`,
	"pT50": `WarningPopup-module__p-t-50___zlPOZ`,
	"pL20": `WarningPopup-module__p-l-20___b3Wsd`,
	"pL30": `WarningPopup-module__p-l-30___zU66E`,
	"pL40": `WarningPopup-module__p-l-40___yMnt_`,
	"pR16": `WarningPopup-module__p-r-16___XIWl6`,
	"pR20": `WarningPopup-module__p-r-20___arTBf`,
	"pR30": `WarningPopup-module__p-r-30___C6jmP`,
	"pR50": `WarningPopup-module__p-r-50___CB6kl`,
	"pR60": `WarningPopup-module__p-r-60___UJL4b`,
	"mB1": `WarningPopup-module__m-b-1___Ue5vq`,
	"mB2": `WarningPopup-module__m-b-2___Q9ou1`,
	"mB6": `WarningPopup-module__m-b-6___C_V7k`,
	"mB8": `WarningPopup-module__m-b-8___UNhwc`,
	"mB10": `WarningPopup-module__m-b-10___nIsdW`,
	"mB14": `WarningPopup-module__m-b-14___lsx5A`,
	"mB16": `WarningPopup-module__m-b-16____rBH0`,
	"mB20": `WarningPopup-module__m-b-20___iQjJk`,
	"mB22": `WarningPopup-module__m-b-22___cSG_O`,
	"mB24": `WarningPopup-module__m-b-24___eWByA`,
	"mB30": `WarningPopup-module__m-b-30___TdCiZ`,
	"mB32": `WarningPopup-module__m-b-32___Q4Whe`,
	"mB40": `WarningPopup-module__m-b-40___Kq4qj`,
	"mT2": `WarningPopup-module__m-t-2___Cyy8e`,
	"mT3": `WarningPopup-module__m-t-3___tWJGV`,
	"mT4": `WarningPopup-module__m-t-4___Y43IZ`,
	"mT5": `WarningPopup-module__m-t-5___rcuHU`,
	"mT8": `WarningPopup-module__m-t-8___MukTv`,
	"mT10": `WarningPopup-module__m-t-10___nkqho`,
	"mT15": `WarningPopup-module__m-t-15___YIC40`,
	"mT16": `WarningPopup-module__m-t-16___Y61xl`,
	"mT20": `WarningPopup-module__m-t-20___sPj3b`,
	"mT22": `WarningPopup-module__m-t-22___CcBIB`,
	"mT30": `WarningPopup-module__m-t-30___N2oPp`,
	"mT32": `WarningPopup-module__m-t-32___enwKP`,
	"mLAuto": `WarningPopup-module__m-l-auto___xOjCP`,
	"mL4": `WarningPopup-module__m-l-4___i4AGF`,
	"mL5": `WarningPopup-module__m-l-5___Fi2bG`,
	"mL6": `WarningPopup-module__m-l-6___jMnVQ`,
	"mL8": `WarningPopup-module__m-l-8___PBq5r`,
	"mL10": `WarningPopup-module__m-l-10___Dbf0B`,
	"mL16": `WarningPopup-module__m-l-16___d84Xu`,
	"mL20": `WarningPopup-module__m-l-20___VH7xH`,
	"mL24": `WarningPopup-module__m-l-24___Ff6yR`,
	"mL30": `WarningPopup-module__m-l-30____so32`,
	"mL35": `WarningPopup-module__m-l-35___LJivh`,
	"mL40": `WarningPopup-module__m-l-40___XfdW1`,
	"mR8": `WarningPopup-module__m-r-8___FdWAY`,
	"mR10": `WarningPopup-module__m-r-10___dNeJ4`,
	"mR16": `WarningPopup-module__m-r-16___RaQR6`,
	"mR20": `WarningPopup-module__m-r-20___Vxc2N`,
	"mR24": `WarningPopup-module__m-r-24___ckHcw`,
	"mR30": `WarningPopup-module__m-r-30___Wt6f_`,
	"mR40": `WarningPopup-module__m-r-40___jmO06`,
	"borderR3": `WarningPopup-module__border-r-3___Hp369`,
	"borderR4": `WarningPopup-module__border-r-4___cq2Cn`,
	"borderR6": `WarningPopup-module__border-r-6___jCdl1`,
	"borderR10": `WarningPopup-module__border-r-10___Hn5kz`,
	"borderR12": `WarningPopup-module__border-r-12___cwuew`,
	"borderR16": `WarningPopup-module__border-r-16___D2bVh`,
	"borderR50": `WarningPopup-module__border-r-50___I_tji`,
	"primaryBorder": `WarningPopup-module__primary-border___wqmvB`,
	"primaryBorderB": `WarningPopup-module__primary-border-b___s9y3Q`,
	"primaryBorderT": `WarningPopup-module__primary-border-t___BCFeI`,
	"primaryBorderL": `WarningPopup-module__primary-border-l___U0uMH`,
	"primaryBorderR": `WarningPopup-module__primary-border-r___u3Bim`,
	"secondaryBorder": `WarningPopup-module__secondary-border___QJ0O0`,
	"secondaryBorderB": `WarningPopup-module__secondary-border-b___lolVn`,
	"secondaryBorderT": `WarningPopup-module__secondary-border-t___opdjC`,
	"secondaryBorderL": `WarningPopup-module__secondary-border-l___hqOUC`,
	"secondaryBorderR": `WarningPopup-module__secondary-border-r___rYr3K`,
	"gap0": `WarningPopup-module__gap-0___g2NWz`,
	"gap2": `WarningPopup-module__gap-2___q268p`,
	"gap4": `WarningPopup-module__gap-4___hqQQ_`,
	"gap5": `WarningPopup-module__gap-5___yIE8u`,
	"gap6": `WarningPopup-module__gap-6___QwRyR`,
	"gap8": `WarningPopup-module__gap-8___tAXZZ`,
	"gap10": `WarningPopup-module__gap-10___loBvk`,
	"gap12": `WarningPopup-module__gap-12___MV9a9`,
	"gap14": `WarningPopup-module__gap-14___Z7NhK`,
	"gap16": `WarningPopup-module__gap-16___QUOEn`,
	"gap18": `WarningPopup-module__gap-18___m_IKQ`,
	"gap20": `WarningPopup-module__gap-20___YGw00`,
	"gap24": `WarningPopup-module__gap-24___dn3ob`,
	"gap26": `WarningPopup-module__gap-26___OOUcZ`,
	"gap30": `WarningPopup-module__gap-30___NAtDb`,
	"gap32": `WarningPopup-module__gap-32___gTPbp`,
	"gap40": `WarningPopup-module__gap-40___P9mKQ`,
	"gap50": `WarningPopup-module__gap-50___ktdGX`,
	"flex1": `WarningPopup-module__flex-1___TXeGO`,
	"flexNone": `WarningPopup-module__flex-none___HxZNX`,
	"flexColumn": `WarningPopup-module__flex-column___DokdP`,
	"flexRow": `WarningPopup-module__flex-row___cJr6s`,
	"verticallyCentered": `WarningPopup-module__vertically-centered___Wl9m8`,
	"horizontallyCentered": `WarningPopup-module__horizontally-centered___huZis`,
	"horizontallyEnd": `WarningPopup-module__horizontally-end___XuHBu`,
	"verticallyStart": `WarningPopup-module__vertically-start___QI0hC`,
	"spaceBetween": `WarningPopup-module__space-between___bxAha`,
	"flexWrap": `WarningPopup-module__flex-wrap___sQocx`,
	"height100": `WarningPopup-module__height-100___f_c2e`,
	"width50": `WarningPopup-module__width-50___Yo5py`,
	"width100": `WarningPopup-module__width-100___JS4o3`,
	"cursorPointer": `WarningPopup-module__cursor-pointer___HVqj9`,
	"cursorNotAllowed": `WarningPopup-module__cursor-not-allowed___Ov_WW`,
	"absoluteCentered": `WarningPopup-module__absolute-centered___dj5_G`,
	"absolute": `WarningPopup-module__absolute___S9Bud`,
	"relative": `WarningPopup-module__relative___aD53w`,
	"fixed": `WarningPopup-module__fixed___yGIGs`,
	"visible": `WarningPopup-module__visible___pCBGi`,
	"invisible": `WarningPopup-module__invisible___tHbEg`,
	"col90": `WarningPopup-module__col-90___iA8ks`,
	"colAuto": `WarningPopup-module__col-auto___wvlo6`,
	"medicalTabs": `WarningPopup-module__medical-tabs___duvtU`,
	"medicalTableNew": `WarningPopup-module__medical-table-new___wmNjb`,
	"noPagination": `WarningPopup-module__no-pagination___oWLTh`,
	"medicalTableEmpty": `WarningPopup-module__medical-table-empty___UEBt0`,
	"iconBtn": `WarningPopup-module__icon-btn___jnHWy`,
	"searchIcon": `WarningPopup-module__search-icon___tsbfu`,
	"disableSelect": `WarningPopup-module__disable-select___GqcOW`,
	"breakWord": `WarningPopup-module__break-word___1wX1Q`,
	"popupClearBtn": `WarningPopup-module__popup-clear-btn___A9hJH`,
	"scrollMB20": `WarningPopup-module__scroll-m-b-20___inSQS`,
	"wrapper": `WarningPopup-module__wrapper___VX3_U`,
	"message": `WarningPopup-module__message___NuFg4`,
	"buttonsContainer": `WarningPopup-module__buttonsContainer___ek_et`
};
module.exports = ___CSS_LOADER_EXPORT___;
